import { Box, Chip, styled, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import LanguageSelector from '../Layout/components/LanguageSelector';
import ThemeModeButton from '../Layout/components/ThemeModeButton';
export const Nav = styled('nav')(({ theme }) => ({
  padding: theme.spacing(4, 6),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  width: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(6, 3),
  },
}));
const LogoHeader = styled('img')(({ theme }) => ({
  width: '130px',
}));

const ImageHeader = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));
const LayoutStatusPageNavbar = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Nav>
      <ImageHeader title="go to website" to="/">
        <LogoHeader
          src={`/static/img/${theme.palette.mode === 'dark' ? 'magicalapi_logo_white.svg' : 'magicalApi-icon.svg'}`}
        />
      </ImageHeader>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: (theme) => theme.spacing(4),
        }}
      >
        <ThemeModeButton />
        <LanguageSelector />
      </Box>
    </Nav>
  );
};
export default LayoutStatusPageNavbar;
